


























































































































import { Vue, Component, Prop } from "vue-property-decorator";
import { TemplateInput } from "@/store/template/types";
import { InputTypes, InputTableType } from "@/store/form/types";

@Component
export default class FormInput extends Vue {
  store = this.$store.direct;

  @Prop() input!: TemplateInput;

  rules = {
    required: (v: any) => !!v || "Campo requerido"
  };

  proxy: InputTableType = {};
  options = {};

  get model() {
    return this.store.state.form.selected[this.input.name.toLowerCase()];
  }

  set model(val: InputTypes) {
    let obj: { [key: string]: InputTypes } = {};
    obj[this.input.name.toLowerCase()] = val;
    this.store.commit.form.UPDATE_SELECTED(obj);
  }

  get disabled() {
    if (!this.input.depends_on || this.input.depends_on.length == 0) {
      return false;
    } else {
      return !this.input.depends_on.find(dep => {
        return (
          !!this.store.state.form.selected[dep.variable.toLowerCase()] &&
          (dep.value ==
            this.store.state.form.selected[dep.variable.toLowerCase()] ||
            dep.value ==
              this.store.state.form.selected[
                dep.variable.toLowerCase()
              ].toString())
        );
      });
    }
  }

  get validEntry() {
    return this.input.headers.every(header => {
      return !header.required || !!this.proxy[header.name];
    });
  }

  get tableHeaders() {
    if (this.input.type == "table") {
      return [{ text: "#", sortable: false, align: "left" }]
        .concat(
          this.input.headers.map((header, index) => {
            return { text: header.label, sortable: false, align: "center" };
          })
        )
        .concat([{ text: "Acción", sortable: false, align: "center" }]);
    }
    return [];
  }

  addEntry() {
    if (this.validEntry) {
      let obj: { [key: string]: InputTypes } = {};
      let arr = [...(this.model as InputTableType[])];
      arr.push(this.proxy);
      obj[this.input.name.toLowerCase()] = arr;
      this.store.commit.form.UPDATE_SELECTED(obj);
      this.proxy = {};
    }
  }

  removeEntry(index: number) {
    let obj: { [key: string]: InputTypes } = {};
    let arr = [...(this.model as InputTableType[])];
    arr.splice(index, 1);
    obj[this.input.name.toLowerCase()] = arr;
    this.store.commit.form.UPDATE_SELECTED(obj);
  }
}
